<template>
<div class="chapter">
<div class="inner_page">
<div id="Title-Page.html" xml:lang="en-US">
<div class="Basic-Text-Frame-21">
<p class="pl-title">Deadly Identity</p>
<p class="pl-author">Lindsay McKenna</p>
<p class="pl-logo"><img alt="Har_HQN_2012_Cab_Blk.ai" class="PL-Logos" src="images/logo.png"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_1.vue?2c59a1e8